import { render, staticRenderFns } from "./ReportLongTermCapacityPage.vue?vue&type=template&id=8365f5b6&scoped=true&"
import script from "./ReportLongTermCapacityPage.vue?vue&type=script&lang=js&"
export * from "./ReportLongTermCapacityPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8365f5b6",
  null
  
)

export default component.exports